import React from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { sanitizeHtml } from "../../../../utils/sanitizeHtml";

// Confirmed against the real backend (2026-10-22): title / description
// (HTML, school-authored) / event_date. event_date can be a single date or
// a range string ("2026-12-31 to 2027-01-08") — only the start is shown here.
const getEventDate = (event) => {
  const raw = event?.event_date || event?.date || event?.start_date;
  const start = raw ? String(raw).split(" to ")[0].trim() : null;
  const parsed = start ? new Date(start) : null;
  if (!parsed || Number.isNaN(parsed.getTime())) {
    return { day: "--", month: "" };
  }
  return {
    day: String(parsed.getDate()).padStart(2, "0"),
    month: parsed.toLocaleString("default", { month: "short" }),
  };
};

const EventRow = ({ event, onSelect, isLast }) => {
  const { day, month } = getEventDate(event);
  const title = event?.title || event?.name || "Event";
  const description = event?.description || event?.details || "";

  return (
    <div
      className={`student-dashboard__event${isLast ? "" : " student-dashboard__event--divided"}`}
      role="button"
      tabIndex={0}
      onClick={() => onSelect(event)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onSelect(event);
      }}
    >
      <div className="student-dashboard__event-date">
        <span className="student-dashboard__event-day">{day}</span>
        <span className="student-dashboard__event-month">{month}</span>
      </div>
      <div className="student-dashboard__event-body">
        <p className="student-dashboard__event-title">{title}</p>
        {description && (
          <p
            className="student-dashboard__event-desc"
            // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify in sanitizeHtml() above
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
          />
        )}
      </div>
      <FaChevronRight className="student-dashboard__event-chevron" />
    </div>
  );
};

/**
 * Simple list of upcoming-event rows. There's no per-event detail page, so
 * every row just takes the student to the full Events list.
 */
const EventsList = ({ events }) => {
  const navigate = useNavigate();

  if (!events?.length) {
    return (
      <div className="sp-card sp-empty-state">
        <p className="mb-0">No upcoming events.</p>
      </div>
    );
  }

  const handleSelect = () => navigate("/student-portal/events");

  return (
    <div className="sp-card student-dashboard__events">
      {events.map((event, index) => (
        <EventRow
          key={event?.id ?? index}
          event={event}
          onSelect={handleSelect}
          isLast={index === events.length - 1}
        />
      ))}
    </div>
  );
};

export default EventsList;
